module.exports = __webpack_public_path__ + "static/media/YM38_2.c84e2135.jpg";